module.exports = __webpack_public_path__ + "media/dashboard/components/Accordion/icons/actions-dfd28a9d2ae074ccfebfc5341479a4cb.svg";